'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgFolder(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M10.8 2.036H6l-.846-.93A1.201 1.201 0 004.302.75H1.2A1.2 1.2 0 00.006 1.955L0 10.045c0 .663.54 1.205 1.2 1.205h9.6c.66 0 1.2-.542 1.2-1.205V3.16c0-.663-.54-1.124-1.2-1.124z", id: "Folder__svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Folder__svg__a" })))));
}

module.exports = SvgFolder;
//# sourceMappingURL=Folder.js.map
